// extracted by mini-css-extract-plugin
export default {"layoutDropDown":"Mailbox_layoutDropDown__LcmSs"};